import React from 'react'
import {Row, Col} from 'reactstrap'

const Cocktails = (props) => {
    console.log(props)
    const cocktails = props.cocktailMenu
    const happyHours = props.happyHours
    console.log(props.cocktailMenu)
  
    
  const getPrice = (number) => {
    let price = parseFloat(number)
    return price
  }
  //const locationName = props.location.name.label

    let buildCocktails = (cocktails) => {
        console.log('cocktails')
        console.log(cocktails)
        return (
            <div className="cocktail-container">
                {cocktails 
                    ?   <div>
                            <div className="cocktail-section">
                                <div className="cocktail-section-title">Cocktails</div>
                                {cocktails.sections[0].items.map(cocktail => (
                                    <div className="cocktail-item">
                                        <div className="cocktail-item-title">{cocktail.name} • <span className="cocktail-price">{getPrice(cocktail.containers[0].price)}</span></div>
                                        <div className="cocktail-item-description">{cocktail.description}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="highnoon-section">
                                <div className="cocktail-section-title mocktail-section">High Noon Hard Seltzer</div>
                                {cocktails.sections[1].items.map(mocktail => (
                                    <div className="cocktail-item">
                                        <div className="cocktail-item-title">
                                            {mocktail.name} <span className="cocktail-price"> • {getPrice(mocktail.containers[0].price)}</span>
                                        </div>
                                        <div className="cocktail-item-description">
                                            {mocktail.description}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mocktail-section">
                                <div className="cocktail-section-title mocktail-section">Mocktails</div>
                                {cocktails.sections[2].items.map(mocktail => (
                                    <div className="cocktail-item">
                                        <div className="cocktail-item-title">
                                            {mocktail.name} <span className="cocktail-price"> • {getPrice(mocktail.containers[0].price)}</span>
                                        </div>
                                        <div className="cocktail-item-description">
                                            {mocktail.description}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            
                        </div>
                    :   <span>loading...</span>}
            </div>
        )
    }
    const buildHappyHours = (happyHours) => {
        return(
            <div className="cocktail-happyhour-container">
            {happyHours
                ?   
                    <div>
                        {props.happyHours.map(promo => (
                            <div className="happy-hour-item">
                                <div className="happy-hour-title">
                                    {promo.name.label}
                                </div>
                                <div className="happy-hour-description">{promo.description}</div>
                            </div>
                        ))}
                    </div>
                
                :   <div>loading...</div>
            }
            </div>
        )
    }
    return (
        <div className="cocktail-mocktails-page-two-column">
            
            <div className="cocktails-left">
                {buildCocktails(cocktails)}
            </div>
            
            <div className="happyhour-right">
                <div className="hh-container">
                    
                        {props.happyHours 
                            ?   <>
                                    {props.happyHours.map((promo, key) => (
                                        <div id={`hh-item-${key}`} className="hh-item">
                                            <div id={`happyhour-title-${key}`} className="happyhour-title">
                                                {promo.name.label}
                                            </div>
                                            <div id={`happyhour-description-${key}`} className="happyhour-description">
                                                {promo.description}
                                            </div>
                                            <div id={`hh-offers-${key}`} className="hh-offers">
                                                {promo.offers.map(offer => (
                                                    <div>
                                                        <div>{offer.offer}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            :   <span>loading...</span>
                        }
                    
                </div>
                
               
            </div>
            
        </div>
    )
}
export default Cocktails